export enum CaseState {
  OPEN = "Open",
  CLOSED = "Closed",
  NEXT_DUE_DATE = "NextDueDate",
  SEND_TO_COURT = "SendToCourt",
  SENTENCE_RECEIVED = "SentenceReceived",
}
